/**
 * Indicates the index of the accordion item.
 * @type {number}
 */
export const index = 'data-index';
/**
 * Present when the accordion item is disabled.
 */
export const disabled = 'data-disabled';
/**
 * Present when the accordion item is open.
 */
export const open = 'data-open';
